import React from 'react';
import {
  Box,
  Checkbox,
  CheckboxGroup,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  Stack,
  Text,
} from '@chakra-ui/core';
import { useTranslation } from 'react-i18next';
import { AppointmentType } from '../../../firebase/firestore/documents/appointmentAvaiability';

type AppointmentSectionProps = {
  appointmentTypes: AppointmentType[];
  bookingCapacity: number;
  isInPersonOnly: () => boolean;
  onAppointmentTypesChange: (types: AppointmentType[]) => void;
  onBookingCapacityChange: (value: number) => void;
};

export const AppointmentSection = ({
  appointmentTypes,
  bookingCapacity,
  isInPersonOnly,
  onAppointmentTypesChange,
  onBookingCapacityChange,
}: AppointmentSectionProps): JSX.Element => {
  const { t } = useTranslation('calendar');

  return (
    <>
      <Box mt={5}>
        <Text>{t('availabilityForm.appointmentTypeLabel')}</Text>
        <CheckboxGroup
          onChange={
            /* istanbul ignore next */ (value) => {
              onAppointmentTypesChange(value as AppointmentType[]);
            }
          }
          value={appointmentTypes}
        >
          <Stack direction="row" mt={2}>
            <Checkbox value="phone" mr={3} data-testid="checkbox1">
              {t('phone')}
            </Checkbox>
            <Checkbox value="video" mr={3}>
              {t('video')}
            </Checkbox>
            <Checkbox value="inPerson" mr={3}>
              {t('inPerson')}
            </Checkbox>
          </Stack>
        </CheckboxGroup>
      </Box>

      <Box mt={5}>
        <Text>{t('availabilityForm.bookingCapacity')}</Text>
        <NumberInput
          onChange={(value: string) => onBookingCapacityChange(parseInt(value, 10))}
          value={isInPersonOnly() ? bookingCapacity : 1}
          size="sm"
          isDisabled={!isInPersonOnly()}
          defaultValue={1}
          min={1}
          max={isInPersonOnly() ? 50 : 1}
          maxW={32}
          mt={2}
        >
          <NumberInputField data-testid="bookingCapacity" />
          <NumberInputStepper>
            <NumberIncrementStepper />
            <NumberDecrementStepper />
          </NumberInputStepper>
        </NumberInput>
      </Box>
    </>
  );
};
